import React from 'react'
import {Listbox} from '@headlessui/react'

import arrowTop from 'assets/arrow-top.svg'
import arrowBottom from 'assets/arrow-bottom-wide.svg'
import mergeTw from 'features/common/utils/mergeClasses'

const Select = ({className, ...props}: Parameters<typeof Listbox>[0]) => {
    const combinedClassName = mergeTw(`relative flex-1 group/select`, className)
    return <Listbox as="div" className={combinedClassName} {...props} />
}

const SelectButton = ({
    children,
    className,
    ...props
}: Parameters<typeof Listbox.Button>[0]) => {
    // group/select and group-data-[...] are needed to avoid conflict
    // with open states fron parent components i.e. modal
    const combinedClassName = mergeTw(
        `
        flex items-center justify-between gap-px 
        w-full px-4 box-border
        border-x-2 border-t-2 
        rounded-t-[1.25rem]
        rounded-b-[1.25rem]
        group-data-[headlessui-state=open]/select:border-black
        group-data-[headlessui-state=open]/select:rounded-b-none
        ui-not-open:border-b-2
        ui-not-open:border-grey-70
    `,
        className,
    )
    return (
        <Listbox.Button className={combinedClassName} {...props}>
            {({open}) => (
                <>
                    {children}
                    <img src={open ? arrowTop : arrowBottom} alt="open" />
                </>
            )}
        </Listbox.Button>
    )
}

const SelectOption = ({
    className,
    ...props
}: Parameters<typeof Listbox.Option>[0]) => {
    const combinedClassName = mergeTw(
        `
        cursor-pointer px-4 py-2 ui-active:text-yellow-40
        flex items-center
    `,
        className,
    )
    return <Listbox.Option className={combinedClassName} {...props} />
}

const SelectOptions = ({
    className,
    ...props
}: Parameters<typeof Listbox.Options>[0]) => {
    const combinedClassName = mergeTw(
        `
        absolute top-full w-full 
        text-left bg-white
        z-20 overflow-hidden
        rounded-b-[1.25rem]
        border-x-2 border-b-2 border-black
        focus-visible:outline-none
    `,
        className,
    )
    return <Listbox.Options className={combinedClassName} {...props} />
}

Select.Button = SelectButton
Select.Options = SelectOptions
Select.Option = SelectOption

export default Select
